export default "__VITE_ASSET__083c1fb0__"